module.exports = __webpack_public_path__ + "static/media/10_plantilla_rec_combo_simple_cp_gaseosas_vidrio_vaso_cc.cc52e1a7.png";